import {UmpireSquad} from '../umpire-squad';
import {UmpireSoccerMatchHalf} from '../umpire-soccer-match-half';
import {UmpireSquadPlayer} from '../umpire-squad-player';
import {UmpireMatch} from '../umpire-match';
import {UmpireIncidentType} from '../umpire-incident-type';
import {UmpireIncidentVerificationStatus} from '../umpire-incident-verification-status';
import {UmpireIncidentSectionTypeEnum} from '../umpire-incident-section-type-enum';
import {UmpireComponent} from '../umpire-component';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';

export interface UmpireIncident {
  type: string;

  id: string;

  content: string | null;

  incident_type: UmpireIncidentType;

  occurrence_half: UmpireSoccerMatchHalf;

  occurrence_minute: number;

  match: UmpireMatch;

  squad: UmpireSquad;

  squad_player: UmpireSquadPlayer;

  secondary_squad: UmpireSquad;

  secondary_squad_player: UmpireSquadPlayer;

  incident_section_type: UmpireIncidentSectionTypeEnum;

  verification_status: UmpireIncidentVerificationStatus;

  component?: UmpireComponent<UmpireComponentTypeEnum>;

  created_at: string;
}
